/* eslint-disable no-sparse-arrays */
import { Route } from "react-router-dom";

//public page
import RegisterPage from "./component/public/register/Register";
import LoginPage from "./component/public/login/Login";
import NewLoginPage from "./component/public/login/NewLogin";
import LoginMohPromt from "./component/public/loginMohPromt/LoginMohPromt";
import LoginHealthID from "./component/public/loginHealthID/LoginHealthID";
import LoginProviderID from "./component/public/loginProviderID/LoginProviderID";
import LoginThaiIDWithRole from "./component/public/loginThaiD/LoginThaiIDWithRole";
import QuestionnairePublic from "./component/public/questionnaire/Questionnaire";

//microservice (in public page)
import GeneResultMicroservice from "./microservice/geneResult/GeneResult";

//landing page
import HomePage from "./component/public/Home";
import ViewAnnouncementPublic from "./component/public/ViewAnnouncementPublic";
import About from "./component/public/about/About";
import InformationPage from "./component/public/Information/Information";
import MapOperationRoom from "./component/public/Information/MapOperationRoom";
import PharmacogeneticTest from "./component/public/Information/PharmacogeneticTest";
import HLA5801 from "./component/public/Information/HLA5801";
import HLAA3101 from "./component/public/Information/HLAA3101";
import HLAB1301 from "./component/public/Information/HLAB1301";
import ContactPage from "./component/public/Contact";
import TermsService from "./component/public/TermsService";
import SearchPatient from "./component/public/searchpatient/SearchPatient";
import IDcardRequestData from "./component/public/IDcardRequestData/IDcardRequestData";

import ContentPage from "./component/public/content/Content";
import ContentPageDetail from "./component/public/content/ContentDetail";

import ContentFormSurvey from "./component/public/Information/FormSurvey";

import RevocationAccount from "./component/public/RevocationAccount";

import PermissionPatient from "./component/public/permissionPatient/PermissionPatient";
import PermissionDoctor from "./component/public/permissionDoctor/PermissionDoctor";
import PermissionHospitalPersonnel from "./component/public/PermissionHospitalPersonnel/PermissionHospitalPersonnel";
import PermissionAdminLab from "./component/public/permissionAdmin/PermissionAdmin";
import PermissionStaff from "./component/public/permissionStaff/PermissionStaff";

//user or patients
import RelatedInfoPage from "./component/public/pagePatient/RelatedInfo";
import ManageInfo from "./component/public/pagePatient/ManageInfo";
import ChangePassWordPatient from "./component/patients/changePass/ChangePass";
import PermissionAccessPatient from "./component/public/pagePatient/PermissionAccessPatient";
import AnsPatient from "./component/public/pagePatient/AnsPatient";
import CommentPatient from "./component/public/pagePatient/CommentPatient";
import ContactPatient from "./component/public/pagePatient/ContactPatient";
import AboutPatient from "./component/public/pagePatient/AboutPatient";
import QuestionnairePatient from "./component/public/pagePatient/QuestionnairePatient";
import HomePatient from "./component/patients/HomePatient";
import UpLevelByMohPromt from "./component/patients/updateInfo/UpLevelByMohPromt";
import UpLevelByThaiD from "./component/patients/updateInfo/UpLevelByThaiD";
import Notification from "./component/public/notification";

// อันใหม่
import LaboratoryResult from "./component/patients/LaboratoryResult";
import MiniAppLaboratoryResult from "./component/miniapp/MiniAppLaboratoryResult";
import MiniApp404 from "./component/miniapp/MiniApp404";

//admin management
import Admin from "./component/admin/HomeAdmin";
import UserManament from "./component/admin/UserManament";
import ManageWebsite from "./component/admin/manageWebsite/ManageWebsite";
//admin manage website
import RelatedDocument from "./component/admin/manageWebsite/RelatedDocument";
import LaboratoryInspectionGuideline from "./component/admin/manageWebsite/LaboratoryInspectionGuideline";
import AddLabTestKidInfomation from "./component/admin/manageWebsite/AddLabTestKidInfomation";
import AddPressRelease from "./component/admin/manageWebsite/AddPressRelease";
import AddQuestionnaire from "./component/admin/manageWebsite/AddQuestionnaire";

import RegisterAdmin from "./component/admin/registerAdmin/RegisterAdmin";
import PermissionAdmin from "./component/admin/permissionAdmin/PermissionAdmin";
import ManageInfoAdmin from "./component/admin/profileAdmin/ManageInfo";
import ChangePasswordAdmin from "./component/admin/profileAdmin/ChangePassword";
import AnsAdmin from "./component/admin/AnsAdmin";
import CommentAdmin from "./component/admin/CommentAdmin";
import AboutAdmin from "./component/admin/AboutAdmin";
import ContactAdmin from "./component/admin/ContactAdmin";
import AddDataUseQuillEditor from "./component/admin/AddDataUseQuillEditor";
import Petition from "./component/admin/labinformation/Petition";
import Repeated from "./component/admin/labinformation/Repeated";
import AnnouncementAdmin from "./component/admin/announcement/AnnouncementAdmin";
import ViewAnnouncementAdmin from "./component/admin/announcement/ViewAnnouncementAdmin";
import AdminSetting from "./component/admin/AdminSetting";
import AdminInformation from "./component/admin/information/AdminInformation";
import InformationMap from "./component/admin/information/InformationMap";
import InformationPharmacogenetic from "./component/admin/information/InformationPharmacogenetic";
import BannerList from "./component/admin/manageWebsite/banner/BannerList";

//operation
import LabManagement from "./component/operationRoom/LabManagement";
import InputData from "./component/operationRoom/InputData";
import AddIndividualData from "./component/operationRoom/AddIndividualData";
import UploadExcelResults from "./component/operationRoom/UploadExcelResults";
import ManageProfileOperation from "./component/operationRoom/ManageProfile";
import ManageUsersOperation from "./component/operationRoom/ManageUsers";
import ChangePasswordOperation from "./component/operationRoom/ChangePassword";
import RelatedinfoLaboratory from "./component/operationRoom/RelatedinfoLaboratory";
import AnsLaboratory from "./component/operationRoom/AnsLaboratory";
import CommentLaboratory from "./component/operationRoom/CommentLaboratory";
import InspectionGuide from "./component/operationRoom/InspectionGuide";
import InspectionGuideDetail from "./component/operationRoom/InspectionGuideDetail";
import AboutLaboratory from "./component/operationRoom/AboutLaboratory";
import ContactLaboratory from "./component/operationRoom/ContactLaboratory";
import HomeOperation from "./component/operationRoom/HomeOperation";
import Newinputdata from "./component/operationRoom/Newinputdata";
import NewinspectionGuide from "./component/operationRoom/NewinspectionGuide";
import GuidelineFormOP from "./component/operationRoom/GuidelineForm";
import NewuploadExcelResults from "./component/operationRoom/NewUploadExcelResults";
import NewAddIndividualData from "./component/operationRoom/NewAddIndividualData";
import NewmanageUsersOperation from "./component/operationRoom/manageUsersOperation";
import NewAddOperationStaff from "./component/operationRoom/NewAddOperationStaff";
import LaboratoryDocumentGuideShow from "./component/operationRoom/LaboratoryDocumentGuideShow";
//doctor
import DoctorManagement from "./component/doctor/DoctorManagement";
import PermisstionLabPatient from "./component/doctor/PermisstionLabPatient";
import PermisstionLabPatientResult from "./component/doctor/PermisstionLabPatientResult";
import SearchDataPatient from "./component/doctor/SearchDataPatient";
import StatusDataPatient from "./component/doctor/StatusDataPatient";
import DataInformation from "./component/doctor/DataInformation";
import GuideCheckInspec from "./component/doctor/GuideCheckInspec";
import DocumentGuide from "./component/doctor/DocumentGuide";
import DocumentGuideShow from "./component/doctor/DocumentGuideShow";
import DoctorManageInfo from "./component/doctor/profileDoctor/ManageInfo";
import DoctorDataAccess from "./component/doctor/profileDoctor/DataAccess";
import AddOperationStaff from "./component/operationRoom/AddOperationStaff";
import AnsMedical from "./component/doctor/AnsMedical";
import CommentMedical from "./component/doctor/CommentMedical";
import ChangePasswordDoctor from "./component/doctor/profileDoctor/ChangePassword";
import ContactMedical from "./component/doctor/ContactMedical";
import AboutMedical from "./component/doctor/AboutMedical";
import GuidelineTextEditor from "./component/doctor/AddGuideline";
import GuidelineForm from "./component/doctor/GuidelineForm";
import HomeDoctor from "./component/doctor/HomeDoctor";
import ViewannouncementDoctor from "./component/doctor/ViewannouncementDoctor";

//ผู้บริหาร
import AggregateResult from "./component/provideradmin/AggregateResult";
import InspectionRateMap from "./component/provideradmin/InspectionRateMap";
import GeneResult from "./component/provideradmin/GeneResult";
import RelatedInfoExecutive from "./component/provideradmin/RelatedInfoExecutive";
import ChangepasswordExecutive from "./component/provideradmin/profileExecutive/ChangepasswordExecutive";
import ManageInfoExecutive from "./component/provideradmin/profileExecutive/ManageInfoExecutive";
import AboutExecutive from "./component/provideradmin/AboutExecutive";
import ContactExecutive from "./component/provideradmin/ContactExecutive";

import Notfound404 from "./component/notfound/Notfound404";
import PermissionStaffOperation from "./component/operationRoom/PermissionStaffOperation";
import AddLabTestData from "./component/admin/AddLabTestData";
import AddHospital from "./component/admin/hospitalsetting/AddorEditHospital";
import HospitalSetting from "./component/admin/manageWebsite/hospital/HospitalSetting";
import HistoryLog from "./component/admin/historyLog/HistoryLog";

import DataAccessRights from "./component/doctor/DataAccessRights";
import PermissionHospital from "./component/admin/permissionAdmin/PermissionHospital";

//โรงพยาบาล
import HospitalManagement from "./component/hospital/HospitalManagement";
import SetupHospital from "./component/hospital/SetupHospital";
import ManageInfoHospital from "./component/hospital/profile/ManageInfoHospital";
import ChangePassword from "./component/hospital/profile/ChangePassword";
import AboutHospital from "./component/hospital/profile/AboutHospital";
import ContactHospital from "./component/hospital/ContactHospital";
import AnsQandA from "./component/public/AnsQandA";
import ViewannouncementLab from "./component/operationRoom/ViewannouncementLab";
import ViewannouncementPatient from "./component/patients/ViewannouncementPatient";
import UsagePolicy from "./component/public/UsagePolicy";
import LoginThaiD from "./component/public/loginThaiD/LoginThaiD";

//เจ้าหน้าที่โรงพยาบาล
import HomeHospital from "./component/hospital/HomeHospital";
import ViewannouncementHospital from "./component/hospital/ViewannouncementHospital";

import HLA5701 from "./component/public/Information/HLA5701";
import HLA1502 from "./component/public/Information/HLA1502";
import NAT2 from "./component/public/Information/NAT2";
import ADRs from "./component/public/Information/ADRs";
import OtpRequest from "./component/public/resetPassword/OtpRequest";
import ConfirmTel from "./component/public/resetPassword/ConfirmTel";
import ForgotPassword from "./component/public/resetPassword/forgotPassword";

//รวม component ที่เป็น "หน้า" ของทั้งระบบ
const PageComponents = {
  //หน้าแรก public
  HomePage: <HomePage />,
  ViewAnnouncementPublic: <ViewAnnouncementPublic />,
  AboutPage: <About />,
  InformationPage: <InformationPage />,
  InformationPageMapOperation: <MapOperationRoom />,
  InformationPagePharmacogeneticTest: <PharmacogeneticTest />,
  InformationPageAdversereactions: <HLA5801 />,
  InformationPageObtainingAllopurinol: <HLA5701 />,
  InformationPageCarbamazepineExposure: <HLA1502 />,
  InformationPageAbacavirUse: <NAT2 />,
  InformationPageIsoniazid: <ADRs />,
  InformationPageCarbamazepine: <HLAA3101 />,
  InformationPageHypersensitivity: <HLAB1301 />,
  ContactPage: <ContactPage />,
  TermsService: <TermsService />,

  SearchPatient: <SearchPatient />,
  IDcardRequestData: <IDcardRequestData />,

  ContentPageDetail: <ContentPageDetail />,
  ContentPage: <ContentPage />,
  ContentFormSurvey: <ContentFormSurvey />,
  QuestionnairePublic: <QuestionnairePublic />,

  RegisterPage: <RegisterPage />,
  LoginPage: <LoginPage />,
  NewLoginPage: <NewLoginPage />,
  LoginMohPromtPage: <LoginMohPromt />,
  LoginHealthIDPage: <LoginHealthID />,
  LoginProviderIDPage: <LoginProviderID />,
  // ResetPasswordPage: <ResetPassword />,
  ForgotPassword: <ForgotPassword />,
  ConfirmTel: <ConfirmTel />,
  OtpRequest: <OtpRequest />,
  PermissionPatientPage: <PermissionPatient />,
  PermissionDoctorPage: <PermissionDoctor />,
  PermissionHospitalPersonnelPage: <PermissionHospitalPersonnel />,
  PermissionAdminPage: <PermissionAdminLab />,
  PermissionStaffPage: <PermissionStaff />,
  AnsQandA: <AnsQandA />,
  UsagePolicy: <UsagePolicy />,
  LoginThaiD: <LoginThaiD />,
  LoginThaiIDWithRole: <LoginThaiIDWithRole />,
  Notification: <Notification />,

  // microservice (using same public)
  GeneResultMicroservice: <GeneResultMicroservice />,

  //หน้าประชาชน
  // HomePatients: <HomePatients />,
  RelatedInfoPage: <RelatedInfoPage />,
  // DegradGenePage: <DegradGenePage />,
  // AllergyGengPage: <AllergyGengPage />,
  // HealthinfoPage: <HealthinfoPage />,
  ManageInfo: <ManageInfo />,
  ChangePassWordPatient: <ChangePassWordPatient />,
  PermissionAccessPatient: <PermissionAccessPatient />,
  AnsPatient: <AnsPatient />,
  CommentPatient: <CommentPatient />,
  ContactPatient: <ContactPatient />,
  AboutPatient: <AboutPatient />,
  QuestionnairePatient: <QuestionnairePatient />,
  LaboratoryResult: <LaboratoryResult />,
  MiniAppLaboratoryResult: <MiniAppLaboratoryResult />,
  MiniApp404: <MiniApp404 />,
  HomePagePatient: <HomePatient />,
  ViewannouncementPatient: <ViewannouncementPatient />,
  UpLevelByMohPromt: <UpLevelByMohPromt />,
  UpLevelByThaiD: <UpLevelByThaiD />,
  RevocationAccount: <RevocationAccount />,

  //หน้าแอดมิน
  UserManament: <UserManament />,
  ManageWebsite: <ManageWebsite />,
  RelatedDocument: <RelatedDocument />,
  LaboratoryInspectionGuideline: <LaboratoryInspectionGuideline />,
  AddLabTestKidInfomation: <AddLabTestKidInfomation />,
  AddPressRelease: <AddPressRelease />,
  AddQuestionnaire: <AddQuestionnaire />,
  AddBanner: <AddQuestionnaire />,
  RegisterAdmin: <RegisterAdmin />,
  PermissionAdmin: <PermissionAdmin />,
  ManageInfoAdmin: <ManageInfoAdmin />,
  ChangePasswordAdmin: <ChangePasswordAdmin />,
  AnsAdmin: <AnsAdmin />,
  CommentAdmin: <CommentAdmin />,
  AboutAdmin: <AboutAdmin />,
  ContactAdmin: <ContactAdmin />,
  AddDataUseQuillEditor: <AddDataUseQuillEditor />,
  AddLabTestData: <AddLabTestData />,
  AddHospitai: <AddHospital />,
  HospitalSetting: <HospitalSetting />,
  HistoryLog: <HistoryLog />,

  PermissionHospital: <PermissionHospital />,
  // HomePageAdmin: <HomeAdmin />,
  HomePageAdmin: <Admin />,
  Petition: <Petition />,
  Repeated: <Repeated />,
  AnnouncementAdmin: <AnnouncementAdmin />,
  ViewAnnouncementAdmin: <ViewAnnouncementAdmin />,
  AdminSetting: <AdminSetting />,
  AdminInformation: <AdminInformation />,
  InformationMap: <InformationMap />,
  InformationPharmacogenetic: <InformationPharmacogenetic />,
  BannerList: <BannerList />,

  //หน้าหมอ ด๊อกเตอร์
  DoctorManagement: <DoctorManagement />,
  PermisstionLabPatient: <PermisstionLabPatient />,
  PermisstionLabPatientResult: <PermisstionLabPatientResult />,
  SearchDataPatient: <SearchDataPatient />,
  StatusDataPatient: <StatusDataPatient />,
  GuideCheckInspec: <GuideCheckInspec />,
  DocumentGuide: <DocumentGuide />,
  DocumentGuideShow: <DocumentGuideShow />,
  DataInformation: <DataInformation />,
  DoctorManageInfo: <DoctorManageInfo />,
  DoctorDataAccess: <DoctorDataAccess />,
  AnsMedical: <AnsMedical />,
  CommentMedical: <CommentMedical />,
  ChangePasswordDoctor: <ChangePasswordDoctor />,
  ContactMedical: <ContactMedical />,
  AboutMedical: <AboutMedical />,
  GuidelineTextEditor: <GuidelineTextEditor />,
  GuidelineForm: <GuidelineForm />,
  DataAccessRights: <DataAccessRights />,
  HomePageDoctor: <HomeDoctor />,
  ViewannouncementDoctor: <ViewannouncementDoctor />,

  //หน้า ห้องปฏิบัติการ
  LabManagement: <LabManagement />,
  InputData: <InputData />,
  AddIndividualData: <AddIndividualData />,
  UploadExcelResults: <UploadExcelResults />,
  ManageProfileOperation: <ManageProfileOperation />,
  ManageUsersOperation: <ManageUsersOperation />,
  AddOperationStaff: <AddOperationStaff />,
  ChangePasswordOperation: <ChangePasswordOperation />,
  RelatedinfoLaboratory: <RelatedinfoLaboratory />,
  AnsLaboratory: <AnsLaboratory />,
  CommentLaboratory: <CommentLaboratory />,
  InspectionGuide: <InspectionGuide />,
  AboutLaboratory: <AboutLaboratory />,
  ContactLaboratory: <ContactLaboratory />,
  InspectionGuideDetail: <InspectionGuideDetail />,
  PermissionStaffOperation: <PermissionStaffOperation />,
  HomePageLaboratort: <HomeOperation />,
  ViewannouncementLab: <ViewannouncementLab />,
  Newinputdata: <Newinputdata />,
  NewinspectionGuide: <NewinspectionGuide />,
  GuidelineFormOP: <GuidelineFormOP />,
  NewuploadExcelResults: <NewuploadExcelResults />,
  NewAddIndividualData: <NewAddIndividualData />,
  NewmanageUsersOperation: <NewmanageUsersOperation />,
  NewAddOperationStaff: <NewAddOperationStaff />,
  LaboratoryDocumentGuideShow: <LaboratoryDocumentGuideShow />,

  //ผู้บริหาร
  AggregateResult: <AggregateResult />,
  InspectionRateMap: <InspectionRateMap />,
  GeneResult: <GeneResult />,
  RelatedInfoExecutive: <RelatedInfoExecutive />,
  // AnsExecutive: <AnsExecutive />,
  // CommentExecutive: <CommentExecutive />,
  ChangepasswordExecutive: <ChangepasswordExecutive />,
  ManageInfoExecutive: <ManageInfoExecutive />,
  AboutExecutive: <AboutExecutive />,
  ContactExecutive: <ContactExecutive />,

  //โรงพยาบาล
  HospitalManagement: <HospitalManagement />,
  SetupHospital: <SetupHospital />,
  ManageInfoHospital: <ManageInfoHospital />,
  ChangePasswordHospital: <ChangePassword />,
  AboutHospital: <AboutHospital />,
  ContactHospital: <ContactHospital />,

  //เจ้าหน้าที่โรงพยาบาล
  HomePageHospital: <HomeHospital />,
  ViewannouncementHospital: <ViewannouncementHospital />,
};

const createLayoutWithComponent = (Routes) => {
  return Routes.map((item) => {
    return { path: item.path, component: PageComponents[item.component] };
  });
};

//หน้าแรก public
const publicRouter = [
  { path: "/", component: "HomePage", role: "PUBLIC_USER" },
  {
    path: "/viewannouncementpublic",
    component: "ViewAnnouncementPublic",
    role: "PUBLIC_USER",
  },
  { path: "/about", component: "AboutPage", role: "PUBLIC_USER" },
  { path: "/information", component: "InformationPage", role: "PUBLIC_USER" },
  {
    path: "/information/mapoperationRoom",
    component: "InformationPageMapOperation",
    role: "PUBLIC_USER",
  },
  {
    path: "/information/pharmacogeneticTest",
    component: "InformationPagePharmacogeneticTest",
    role: "PUBLIC_USER",
  },
  // { path: '/information/pharmacogeneticTest/Page1', component: 'InformationPageAdversereactions', role: 'PUBLIC_USER' },
  {
    path: "/information/pharmacogeneticTest/HLAB5801",
    component: "InformationPageAdversereactions",
    role: "PUBLIC_USER",
  },
  // { path: '/information/pharmacogeneticTest/Page2', component: 'InformationPageObtainingAllopurinol', role: 'PUBLIC_USER' },
  {
    path: "/information/pharmacogeneticTest/HLAB5701",
    component: "InformationPageObtainingAllopurinol",
    role: "PUBLIC_USER",
  },
  // { path: '/information/pharmacogeneticTest/Page3', component: 'InformationPageCarbamazepineExposure', role: 'PUBLIC_USER' },
  {
    path: "/information/pharmacogeneticTest/HLAB1502",
    component: "InformationPageCarbamazepineExposure",
    role: "PUBLIC_USER",
  },
  // { path: '/information/pharmacogeneticTest/Page4', component: 'InformationPageAbacavirUse', role: 'PUBLIC_USER' },
  {
    path: "/information/pharmacogeneticTest/NAT2",
    component: "InformationPageAbacavirUse",
    role: "PUBLIC_USER",
  },
  // { path: '/information/pharmacogeneticTest/Page5', component: 'InformationPageIsoniazid', role: 'PUBLIC_USER' },
  {
    path: "/information/pharmacogeneticTest/ADRs",
    component: "InformationPageIsoniazid",
    role: "PUBLIC_USER",
  },
  {
    path: "/information/pharmacogeneticTest/HLAA3101",
    component: "InformationPageCarbamazepine",
    role: "PUBLIC_USER",
  },
  {
    path: "/information/pharmacogeneticTest/HLAB1301",
    component: "InformationPageHypersensitivity",
    role: "PUBLIC_USER",
  },
  { path: "/contact", component: "ContactPage", role: "PUBLIC_USER" },
  { path: "/termsService", component: "TermsService", role: "PUBLIC_USER" },

  {
    path: "/search-for-patient-information",
    component: "SearchPatient",
    role: "PUBLIC_USER",
  },
  {
    path: "/search-for-patient-information/IDcard-request-data",
    component: "IDcardRequestData",
    role: "PUBLIC_USER",
  },

  { path: "/:slug", component: "ContentPage", role: "PUBLIC_USER" },
  {
    path: "/information/:slug",
    component: "ContentFormSurvey",
    role: "PUBLIC_USER",
  },
  {
    path: "/:slug/:content_id",
    component: "ContentPageDetail",
    role: "PUBLIC_USER",
  },
  {
    path: "/personnelHospital/manageInfoHospital",
    component: "ManageInfoHospital",
    role: "PUBLIC_USER",
  },

  {
    path: "/personnelHospital/changePassword",
    component: "ChangePasswordHospital",
    role: "PUBLIC_USER",
  },
  // {
  //   path: "/resetPassword",
  //   component: "ResetPasswordPage",
  //   role: "PUBLIC_USER",
  // },
  {
    path: "/forgotPassword",
    component: "ForgotPassword",
    role: "PUBLIC_USER",
  },
  {
    path: "/forgotPassword/confirmTel",
    component: "ConfirmTel",
    role: "PUBLIC_USER",
  },
  {
    path: "/forgotPassword/otpRequest",
    component: "OtpRequest",
    role: "PUBLIC_USER",
  },
  { path: "/register", component: "RegisterPage", role: "PUBLIC_USER" },
  // { path: '/login', component: 'LoginPage', role: 'PUBLIC_USER' },
  { path: "/login", component: "NewLoginPage", role: "PUBLIC_USER" },
  {
    path: "/loginMohPromt/:role",
    component: "LoginMohPromtPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/loginHealthID",
    component: "LoginHealthIDPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/loginProviderID",
    component: "LoginProviderIDPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/permissionPatient",
    component: "PermissionPatientPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/permissionDoctor",
    component: "PermissionDoctorPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/permissionHospitalPersonnel",
    component: "PermissionHospitalPersonnelPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/permissionAdminLab",
    component: "PermissionAdminPage",
    role: "PUBLIC_USER",
  },
  {
    path: "/permissionStaff",
    component: "PermissionStaffPage",
    role: "PUBLIC_USER",
  },
  { path: "/ansQandA", component: "AnsQandA", role: "PUBLIC_USER" },
  { path: "/usagePolicy", component: "UsagePolicy", role: "PUBLIC_USER" },
  // { path: '/loginThaiD', component: 'LoginThaiD', role: 'PUBLIC_USER' },
  {
    path: "/loginThaiD/:role",
    component: "LoginThaiIDWithRole",
    role: "PUBLIC_USER",
  },

  // microservice (usign same public)
  {
    path: "/geneResultMicroservice",
    component: "GeneResultMicroservice",
    role: "PUBLIC_USER",
  },

  {
    path: "/upLevelByMohPromt",
    component: "UpLevelByMohPromt",
    role: "PUBLIC_USER",
  },

  {
    path: "/revocationAccount",
    component: "RevocationAccount",
    role: "PUBLIC_USER",
  },

  {
    path: "/questionnaire",
    component: "QuestionnairePublic",
    role: "PUBLIC_USER",
  },
  { path: "/notification", component: "Notification", role: "PUBLIC_USER" },
  {
    path: "/patient/laboratoryresult",
    component: "LaboratoryResult",
    role: "PUBLIC_USER",
  },
  {
    path: "/miniapp/laboratoryresult",
    component: "MiniAppLaboratoryResult",
    role: "PUBLIC_USER",
  },
  {
    path: "/miniapp/*",
    component: "MiniApp404",
    role: "PUBLIC_USER",
  },
];

//หน้าประชาชน
const patientsRouter = [
  ...publicRouter,
  // { path: '/homepatients', component: 'HomePatients', role: '' }, ปิด version เก่า
  { path: "/relatedinfo", component: "RelatedInfoPage", role: "" },
  // { path: '/patient/degradgene', component: 'DegradGenePage', role: '' }, ปิด version เก่า
  // { path: '/allergy', component: 'AllergyGengPage', role: '' }, ปิด version เก่า
  // { path: '/healthinfo', component: 'HealthinfoPage', role: '' },
  { path: "/manageinfo", component: "ManageInfo", role: "" },

  {
    path: "/patient/laboratoryresult",
    component: "LaboratoryResult",
    role: "",
  },

  { path: "/patient/ans", component: "AnsPatient", role: "" },
  { path: "/patient/comment", component: "CommentPatient", role: "" },
  { path: "/patient/contact", component: "ContactPatient", role: "" },
  { path: "/patient/about", component: "AboutPatient", role: "" },
  {
    path: "/patient/permissionAccessData",
    component: "PermissionAccessPatient",
    role: "",
  },
  {
    path: "/patient/changePassword",
    component: "ChangePassWordPatient",
    role: "",
  },
  {
    path: "/patient/questionnaire",
    component: "QuestionnairePatient",
    role: "",
  },
  // { path: '/patient/home', component: 'HomePagePatient', role: '' },
  {
    path: "/viewannouncementPatient",
    component: "ViewannouncementPatient",
    role: "",
  },
  { path: "/loginThaiD/:role/:uid", component: "UpLevelByThaiD", role: "" },
];

//หน้าด๊อกเตอร์
const medicalRouter = [
  ...publicRouter,

  { path: "/doctor/:section", component: "DoctorManagement", role: "" }, // sidebar main
  {
    path: "/doctor/:section/:subsection",
    component: "DoctorManagement",
    role: "",
  }, // sidebar submenu
  {
    path: "/doctor/:section/:subsection/:action",
    component: "DoctorManagement",
    role: "",
  }, // sidebar action
  { path: "/GuidelineTextEditor", component: "GuidelineTextEditor", role: "" },

  {
    path: "/permission-lab-patient",
    component: "PermisstionLabPatientResult",
    role: "",
  },
  { path: "/document-guide", component: "DocumentGuide", role: "" },
  { path: "/document-guide/:id", component: "DocumentGuideShow", role: "" },
  { path: "/guideline-form", component: "GuidelineForm", role: "" },
  { path: "/searchDataPatient", component: "SearchDataPatient", role: "" },
  { path: "/statusDataPatient", component: "StatusDataPatient", role: "" },
  { path: "/guideCheckInspec", component: "GuideCheckInspec", role: "" },
  { path: "/dataInformation", component: "DataInformation", role: "" },
  { path: "/doctor/ManageInfo", component: "DoctorManageInfo", role: "" },
  { path: "/doctor/DataAccess", component: "DoctorDataAccess", role: "" },
  { path: "/doctor/ans", component: "AnsMedical", role: "" },
  { path: "/doctor/comment", component: "CommentMedical", role: "" },

  { path: "/doctor/contact", component: "ContactMedical", role: "" },
  // { path: '/doctor/about', component: 'AboutMedical', role: '' },
  {
    path: "/doctor/changePassword",
    component: "ChangePasswordDoctor",
    role: "",
  },
  { path: "/dataAccessRights", component: "DataAccessRights", role: "" },
  // { path: '/doctor/home', component: 'HomePageDoctor', role: '' },
  {
    path: "/viewannouncementDoctor",
    component: "ViewannouncementDoctor",
    role: "",
  },
  { path: "/loginThaiD/:role/:uid", component: "UpLevelByThaiD", role: "" },
];

//หน้าแอดมิน
const AdminRouter = [
  ...publicRouter,
  // default apge
  // { path: '/usermanagement', component: 'UserManament', role: '' },
  { path: "/documentManagement", component: "ManageWebsite", role: "" },
  // { path: '/managewebsite', component: 'ManageWebsite', role: '' },
  {
    path: "/managewebsite/related-document",
    component: "RelatedDocument",
    role: "",
  },
  {
    path: "/managewebsite/laboratory-inspection-guideline",
    component: "LaboratoryInspectionGuideline",
    role: "",
  },
  {
    path: "/managewebsite/add-lab-test-kid",
    component: "AddLabTestKidInfomation",
    role: "",
  },
  {
    path: "/managewebsite/add-lab-test-kid/add-edit-lab-test-kid-data",
    component: "AddLabTestData",
    role: "",
  },
  {
    path: "/managewebsite/add-press-release",
    component: "AddPressRelease",
    role: "",
  }, // ข่าวสารเเละประชาสัมพันธ์
  {
    path: "/managewebsite/add-press-release/add-data-use-quill-editor",
    component: "AddDataUseQuillEditor",
    role: "",
  },
  {
    path: "/managewebsite/add-questionnaire",
    component: "AddQuestionnaire",
    role: "",
  },
  {
    path: "/managewebsite/add-banner",
    component: "AddBanner",
    role: "",
  },
  // คำถามที่พบบ่อย
  {
    path: "/managewebsite/AddDataUseQuillEditor",
    component: "AddDataUseQuillEditor",
    role: "",
  }, // เพิ่ม หน่วยตรวจ

  /** หน้า list แบนเนอร์ */
  // {
  //   path: "/admin/management/banner",
  //   component: "BannerList",
  //   role: "",
  // },

  { path: "/registerAdmin", component: "RegisterAdmin", role: "" },
  { path: "/permissionAdmin", component: "PermissionAdmin", role: "" },
  { path: "/admin/ManageInfo", component: "ManageInfoAdmin", role: "" },
  // { path: '/admin/AddEditLabTestData', component: 'AddLabTestData', role: '' },
  { path: "/admin/AddHospital", component: "AddHospitai", role: "" },
  { path: "/hospitalsetting", component: "HospitalSetting", role: "" },
  { path: "/historyLog", component: "HistoryLog", role: "" },

  { path: "/admin/contact", component: "ContactAdmin", role: "" },
  { path: "/admin/about", component: "AboutAdmin", role: "" },
  // { path: '/admin/ans', component: 'AnsAdmin', role: '' },
  { path: "/admin/comment", component: "CommentAdmin", role: "" },
  { path: "/admin/changepassword", component: "ChangePasswordAdmin", role: "" },
  { path: "/permissionHospital", component: "PermissionHospital", role: "" },
  { path: "/admin", component: "HomePageAdmin", role: "" },

  { path: "/labinformation/petition", component: "Petition", role: "" },
  { path: "/labinformation/repeated", component: "Repeated", role: "" },

  { path: "/admin/information", component: "AdminInformation", role: "" },

  {
    path: "/admin/information/pharmacogeneticTest",
    component: "InformationPharmacogenetic",
    role: "",
  },
  {
    path: "/admin/information/pharmacogeneticTest",
    component: "InformationPharmacogenetic",
    role: "",
  },

  { path: "/admin/news", component: "AnnouncementAdmin", role: "" },
  {
    path: "/admin/news/:content_id",
    component: "ViewAnnouncementAdmin",
    role: "",
  },
  { path: "/admin/:section", component: "AdminSetting", role: "" }, // sidebar main
  { path: "/admin/:section/:subsection", component: "AdminSetting", role: "" }, // sidebar submenu
  {
    path: "/admin/:section/:subsection/:action",
    component: "AdminSetting",
    role: "",
  }, // sidebar action
  {
    path: "/admin/:section/:subsection/:action/:id",
    component: "AdminSetting",
    role: "",
  }, // sidebar action
];

//ปฏิบัตการ มิ้น
const LaboratoryPersonnelAdminRouter = [
  ...publicRouter,
  { path: "/laboratory/:section", component: "LabManagement", role: "" }, // sidebar main

  {
    path: "/laboratory/:section/:subsection",
    component: "LabManagement",
    role: "",
  }, // sidebar submenu
  {
    path: "/laboratory/:section/:subsection/:action",
    component: "LabManagement",
    role: "",
  }, // sidebar action
  // { path: "/inputdata", component: "InputData", role: "" },
  // { path: "/addIndividualdata", component: "AddIndividualData", role: "" },
  // { path: "/uploadExcelResults", component: "UploadExcelResults", role: "" },
  {
    path: "/laboratory/manageProfileOperation",
    component: "ManageProfileOperation",
    role: "",
  },
  // {
  //   path: "/manageUsersOperation",
  //   component: "ManageUsersOperation",
  //   role: "",
  // },
  { path: "/addOperationStaff", component: "AddOperationStaff", role: "" },
  {
    path: "/inputdata/uploadExcelResults",
    component: "NewuploadExcelResults",
    role: "",
  },
  {
    path: "/inputdata/AddIndividualData",
    component: "NewAddIndividualData",
    role: "",
  },

  {
    path: "/permissionStaffOperation",
    component: "PermissionStaffOperation",
    role: "",
  },

  { path: "/laboratory/contact", component: "ContactLaboratory", role: "" },
  { path: "/laboratory/about", component: "AboutLaboratory", role: "" },
  { path: "/laboratory/ans", component: "AnsLaboratory", role: "" },
  { path: "/laboratory/comment", component: "CommentLaboratory", role: "" },
  { path: "/inputdata", component: "Newinputdata", role: "" },
  { path: "/inspectionGuide", component: "NewinspectionGuide", role: "" },
  { path: "/guidelineForm", component: "GuidelineFormOP", role: "" },
  { path: "/addStaff", component: "NewAddOperationStaff", role: "" },
  {
    path: "/inspectionGuide/:id",
    component: "LaboratoryDocumentGuideShow",
    role: "",
  },

  {
    path: "/laboratory/relatedinfo",
    component: "RelatedinfoLaboratory",
    role: "",
  },
  {
    path: "/laboratory/changepassword",
    component: "ChangePasswordOperation",
    role: "",
  },
  { path: "/laboratory/home", component: "HomePageLaboratort", role: "" },
  { path: "/viewannouncementLab", component: "ViewannouncementLab", role: "" },
  {
    path: "/manageUsersOperation",
    component: "NewmanageUsersOperation",
    role: "",
  },

  { path: "/loginThaiD/:role/:uid", component: "UpLevelByThaiD", role: "" },
];

//ผู้บริหาร
const ExecutiveRouter = [
  {
    path: "/manager/aggregateResult",
    component: "AggregateResult",
    layout: "NavLayoutDefault",
  },
  {
    path: "/manager/geneResult",
    component: "GeneResult",
    layout: "NavLayourDefault",
  },
  {
    path: "/manager/inspectionRateMap",
    component: "InspectionRateMap",
    layout: "NavLayourDefault",
  },
  {
    path: "/manager/relatedinfo",
    component: "RelatedInfoExecutive",
    layout: "NavLayourDefault",
  },
  // { path: '/manager/ans', component: 'AnsExecutive', layout: 'NavLayourDefault' },
  {
    path: "/manager/about",
    component: "AboutExecutive",
    layout: "NavLayourDefault",
  },
  {
    path: "/manager/contact",
    component: "ContactExecutive",
    layout: "NavLayourDefault",
  },
  // { path: '/manager/comment', component: 'CommentExecutive', layout: 'NavLayourDefault' },
  {
    path: "/manager/changepassword",
    component: "ChangepasswordExecutive",
    layout: "NavLayourDefault",
  },
  {
    path: "/manager/manageinfo",
    component: "ManageInfoExecutive",
    layout: "NavLayourDefault",
  },
];

// โรงพยาบาล
const HospitalRouter = [
  ...publicRouter,
  { path: "/hospital/:section", component: "HospitalManagement", role: "" }, // sidebar main
  {
    path: "/hospital/:section/:subsection",
    component: "HospitalManagement",
    role: "",
  }, // sidebar submenu
  {
    path: "/hospital/:section/:subsection/:action",
    component: "HospitalManagement",
    role: "",
  }, // sidebar action
  // { path: '/setupHospital', component: 'SetupHospital', role: '' },
  {
    path: "/hospital/manageInfoHospital",
    component: "ManageInfoHospital",
    role: "",
  },
  {
    path: "/hospital/changePassword",
    component: "ChangePasswordHospital",
    role: "",
  },
  { path: "/hospital/contact", component: "ContactHospital", role: "" },
  { path: "/hospital/about", component: "AboutHospital", role: "" },
];

const HospitalPersonnelRouter = [
  ...publicRouter,
  { path: "/hospital/home", component: "HomePageHospital", role: "" },
  { path: "/hospital/about", component: "AboutHospital", role: "" },
];

export const get404Route = () => (
  <Route path="/404" element={<Notfound404 />} />
);
export const publicRouteWithLayout = createLayoutWithComponent(publicRouter);
export const patientsRouteWithLayout =
  createLayoutWithComponent(patientsRouter);
export const medicalRouteWithLayout = createLayoutWithComponent(medicalRouter);
export const operationRoomRouteLayout = createLayoutWithComponent(
  LaboratoryPersonnelAdminRouter,
);
export const adminRouteWithLayout = createLayoutWithComponent(AdminRouter);
export const executiveRouteWithLayout =
  createLayoutWithComponent(ExecutiveRouter);
export const hospitalRouteWithLayout =
  createLayoutWithComponent(HospitalRouter);
export const hospitalPersonnelRouteWithLayout = createLayoutWithComponent(
  HospitalPersonnelRouter,
);
